import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { startJob, startBhHouseJob, sendMsgToRocketChat, updateWorkFlow } from "../../commonApis"
import CancelEntryModal from "./cancelEntry";
import { selectCancelReasonList } from "@EUForms/selectors";
import { useSelector } from "react-redux";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const EUStartJobButton = (props) => {
    const EntryState = props.jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
    const ESCustomState = props.jobWheels["ES_CUSTOM_JOB_WHEEL"]?.value?.state || ""
    const BrokerHouse = props.jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']?.value.state || ""
    const declarationEntryType = props.declType;
    const transmissionType = props.transmissionType;
    const isCCDocEndRequest = props.isCCDocEndRequest
    const version = props.version;
    const [type, setType] = React.useState(null);
    const [eventType, setEventType] = React.useState(null);
    const [formType, setFormType] = React.useState(null);
    const [disableStartBtn, setDisableStartBtn] = useState(!!declarationEntryType && !!transmissionType && !ESCustomState.includes("NONE"))
    const [fileWithGateway, setFileWithGateway] = useState('1');
    const [showModal, setShowModal] = useState(false);
    const serviceType = props.serviceType
    const cancelReasonList = useSelector(selectCancelReasonList);
    let brokerUserGuid = props?.kxUser?.userBasicInfo?.userGuid;
    const { currentJobData, kxEngineUserInfo } = useCurrentShipmentType();
    // const isEngineUser = kxEngineUserInfo?.isEngineUser=='true' || false
    //console.log("cancelReasonList", cancelReasonList)
    const { translate } = props;
    useEffect(() => {
        let _type = 'ENTRY_IN_PROCESS';
        let _eventType = `TYPE_${declarationEntryType}_NEW`;
        let _formType = `TYPE_${declarationEntryType}`;
        if (EntryState === "STATE_ENTRY_ACCEPTED") {
            _type = `TYPE_${declarationEntryType}_NEW`;
            _eventType = 'ENTRY_AMEND_IN_PROCESS'
             _formType = `TYPE_${declarationEntryType}_MOD`;
        }
        setType(_type);
        setEventType(_eventType);
        setFormType(_formType);
    }, [declarationEntryType, transmissionType])


    const startJobClickHandler = async () => {
       await startBhHouseJob(props.shipId, "BH_BROKER_ASSIGNED", brokerUserGuid);
       await startBhHouseJob(props.shipId, "BH_BROKER_IN_PROCESS", brokerUserGuid)
       await sendMsgToRocketChat(props.shipId, 13, brokerUserGuid);          
    }

    let stateInProcess = (EntryState.includes('NONE') || EntryState.includes('ENTRY_IN_PROCESS'));

    return (
      <>
        {['A', 'B', 'C', 'D', 'X', 'Y'].includes(declarationEntryType) &&
          !ESCustomState.includes('STATE_CANCEL_FILED') &&
          !ESCustomState.includes('STATE_CANCEL_ACCEPTED') &&
          transmissionType === 'CAN' && (
            <CancelEntryModal
              key='updateResponseBtn'
              shipmentId={window.shipmentId}
              fileWithGateway={fileWithGateway}
              showModal={showModal}
              setShowModal={setShowModal}
              cancelReason={''}
              language='es'
              countryCode='ES'
              serviceType={serviceType}
              version={version}
              cancelReasonList={cancelReasonList || null}
              trigger={
                <Button
                  size='mini'
                  key='CANCEL_ES'
                  disabled={false}
                  className='sv todo-button primaryBtn'
                  onClick={() => {
                    setShowModal(true)
                  }}
                >
                  {translate(`CANCEL`).toUpperCase()}
                </Button>
              }
              lowerEnv={props?.lowerEnv}
              searchByID={props?.searchByID}
            />
          )}
        {EntryState.includes('ACCEPTED') &&
          declarationEntryType === 'D' &&
          transmissionType === 'MOD' && (
            <Button
              size='mini'
              key='START_JOB_EU'
              disabled={false}
              className='sv todo-button primaryBtn'
              onClick={(e) => {                
                // const extraParams = isEngineUser ? {country:'ES'} : {}
                e.stopPropagation()
                updateWorkFlow(props.shipId, 'ENTRY_AMEND_IN_PROCESS', brokerUserGuid).then(() => {
                  updateWorkFlow(
                    props.shipId,
                    `TYPE_${declarationEntryType}_AMEND_NEW`,
                    brokerUserGuid
                  ).then(() => {
                    setTimeout(() => {
                      document.getElementById(`card-${props.shipId}`).click()
                    }, 0)
                  })
                })
              }}
            >
              {translate(`AMEND`).toUpperCase()}
            </Button>
          )}
        {
        !(transmissionType === 'CAN' || transmissionType === 'MOD') &&
          !EntryState.includes('ENTRY_READY') &&
          !EntryState.includes('FILED') && (
            (EntryState.includes('ACCEPTED') && transmissionType === 'PRE') ||
              (ESCustomState.includes('RELEASED') && transmissionType !== 'NEW') ||
              (!ESCustomState.includes(`_${declarationEntryType}_ACCEPTED`) &&
                transmissionType == 'NEW') ||
              (declarationEntryType === 'A' &&
                transmissionType === 'CER' &&
                currentJobData?.aesStatus == 'SA') ||
              (EntryState.includes('ACCEPTED') &&
                ['A', 'B', 'C'].includes(declarationEntryType) &&
                transmissionType === 'DOC' &&
                !(isCCDocEndRequest === '1' && ESCustomState.includes('TYPE_DOC_ACCEPTED')))
          ) && (
            <Button
              size='mini'
              key='START_JOB_EU'
              disabled={false}
              className='sv todo-button primaryBtn'
              onClick={(e) => {
                e.stopPropagation()
                if(BrokerHouse!== "BH_BROKER_IN_PROCESS"){
                  startJobClickHandler();
                }
                updateWorkFlow(props.shipId, 'ENTRY_IN_PROCESS', brokerUserGuid).then(() => {
                  updateWorkFlow(props.shipId, `TYPE_${transmissionType=="NEW"? declarationEntryType: transmissionType}_NEW`, brokerUserGuid).then(
                    () => {
                      setTimeout(() => {
                        document.getElementById(`card-${props.shipId}`).click()
                      }, 0)
                    }
                  )
                })
              }}
            >
              {`${translate('START_TYPE')} ${declarationEntryType} ${transmissionType}`}
            </Button>
          )}
      </>
    )

}

export default EUStartJobButton;



